module.exports = __webpack_public_path__ + "img/icon-warning-generic-4.c9cad15e.svg";